import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import theme from '@/styles/theme';

interface Props {
  size?: number;
  containerStyle?: CSSProperties;
  backgroundColor?: string;
  children?: ReactNode;
}

const IconFrame = ({ size = 32, backgroundColor = theme.color.yellow200, children, containerStyle }: Props) => {
  return (
    <Wrapper size={size} backgroundColor={backgroundColor} style={{ ...containerStyle }}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.span<{ size: number; backgroundColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  ${({ size, backgroundColor }) => `
    background: ${backgroundColor};
    width: ${size}px;
    height: ${size}px; 
  `}
`;

export default IconFrame;
